/**
 * App Component
 */

import { useEffect } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { TooltipProvider } from '@/components/common';
import { queryClient } from '@/lib/query-client';
import { AppRouter } from '@/router';
import { useAuthStore } from '@/stores';
import { setAuthTokens } from '@/lib/axios';

import '@/lib/i18n';
import '@/styles/index.css';

export default function App() {
  const { accessToken, refreshToken, updateAccessToken, logout } = useAuthStore();

  // Set up axios interceptors with auth tokens
  useEffect(() => {
    setAuthTokens(
      accessToken,
      refreshToken,
      updateAccessToken,
      logout
    );
  }, [accessToken, refreshToken, updateAccessToken, logout]);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <AppRouter />
      </TooltipProvider>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}
